export class ProjectChecklistInput {
    public name: string = '';
    public description = '';
    public order = 0;
    public projectId = 0;
}
